import { defineComponent as _defineComponent } from 'vue'
import { formatDateInputPicker } from '@/utils/formatDates';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewDateTime',
  props: {
    value: {
        type: String,
        default: '',
    },
    isLine: {
        type: Boolean,
        default: true,
    },
    isWithTime: {
        type: Boolean,
        default: true,
    },
    dateFormat: {
        type: String,
        default: 'dd.MM.yyyy',
    },
    dateColor: {
        type: String,
        default: 'currentColor',
    },
    timeColor: {
        type: String,
        default: '#9BA4AE',
    },
    isSeconds: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props




return { __sfc: true,props, formatDateInputPicker }
}

})